import { Component, Input, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import * as d3 from 'd3';
import { CommonModule, DecimalPipe } from '@angular/common';

import { SimpleChartConfigurations } from './simple-circle-chart.configurations';


@Component({
  selector: 'kla-simple-circle-chart',
  templateUrl: './simple-circle-chart.component.html',
  styleUrls: ['./simple-circle-chart.component.scss'],
  providers: [
    DecimalPipe
  ],
  standalone: true,
  imports: [ CommonModule ]
})
export class SimpleCircleChartComponent implements AfterViewInit {

  @ViewChild('circleChart', {static: true}) private chartContainer: ElementRef;

  @Input()
  public config: SimpleChartConfigurations;

  constructor(
    private numberPipe: DecimalPipe
  ) { }

  ngAfterViewInit(): void {
    const percent = this.config.value;
    const ratio = this.config.value / 100;
    const pie = d3.pie()
      .value((d: any) => {
        return d;
      })
      .sort(null);

    const outerRadius = (this.config.width / 2) - 10;
    const innerRadius = 43;

    const arc = d3.arc()
      .innerRadius(innerRadius)
      .outerRadius(outerRadius)
      .startAngle(0)
      .endAngle(2 * Math.PI);

    const arcLine = d3.arc()
      .innerRadius(innerRadius)
      .outerRadius(outerRadius)
      .cornerRadius(20)
      .startAngle(-0.05);

    const svg = d3.select(this.chartContainer.nativeElement).append('svg');
    svg.attr('width', this.config.width);
    svg.attr('height', this.config.height);
    svg.attr('class', 'shadow');
    const g = svg.append('g');
    g.attr('transform', 'translate(' + this.config.width / 2 + ',' + this.config.height / 2 + ')');

    const pathBackground = g.append('path')
      .datum({ endAngle: 2 * Math.PI })
      .attr('d', arc)
      .attr('class', 'arcBack')
      .attr('fill', this.config.colorBackground);

    const pathForeground = g.append('path')
      .datum({ endAngle: 0 })
      .attr('d', arcLine)
      .attr('fill', this.config.colorForeground);

    const circle = this.createCircle(g, innerRadius, this.config.colorCircle);

    const middleCount = g.append('text')
      .datum(0)
      .text((d) => {
        return this.config.circleText || (d);
      })
      .attr('font-size', '13px')
      .attr('class', 'middleText')
      .attr('text-anchor', 'middle')
      .attr('dy', 7)
      .attr('fill', <any>d3.rgb(this.config.colorPercent));

    let oldValue = 0;
    const arcTween = (transition, newValue, oldValue) => {
      transition.attrTween('d', (d) => {
        const interpolate = d3.interpolate(d.endAngle, ((2 * Math.PI)) * (newValue / 100));

        const interpolateCount = d3.interpolate(oldValue, newValue);
        return (t) => {
          d.endAngle = interpolate(t);
          middleCount.text(this.config.circleText || (this.numberPipe.transform(Math.floor(interpolateCount(t)))));
          return arcLine(d);
        };
      });
    };

    const animate = () => {

      pathForeground.transition()
        .duration(750)
        .ease((time: number) => time)
        .call(arcTween, percent, oldValue);
      oldValue = this.config.value;
    };
    setTimeout(animate, 0);
  }

  private createCircle(g: any, innerRadius: any, color: any) {
    g.append('circle')
      .attr('cx', 0)
      .attr('cy', 0)
      .attr('r', innerRadius)
      .attr('fill', this.config.colorCircle)
      .attr('filter', .5);
  }
}
